import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import StartTime from '../../../images/StartTime.svg'
import EndTime from '../../../images/EndTime.svg'
import TimeSpend from '../../../images/TimeSpend.svg'
import { calculateTimeTaken } from '../../../utils/helpers'
import UseTranslation from '../../../hooks/UseTranslation'

const TimeBox = ({ startDate, endDate, customStyle }) => {
  const timeTaken = calculateTimeTaken(startDate, endDate)
  const { t } = UseTranslation()
  return (
    <Box sx={[styles.timeContainer, customStyle && customStyle]}>
      <Box sx={styles.boxStyle}>
        <Box component={'img'} src={StartTime} alt='StartTime' sx={styles.iconContainer} />
          <Box sx={styles.TimeInfo}>
            <Typography variant="body1" sx={styles.numberStyle}>
              {startDate}
            </Typography>
            <Box sx={styles.subtitleStyle}>{`${t?.['Start Date - Time']}`}</Box>
          </Box>

      </Box>
      <Box sx={styles.boxStyle}>
        <Box component={'img'} src={EndTime} alt='StartTime' sx={styles.iconContainer} />
          <Box sx={styles.TimeInfo}>
            <Typography variant="body1" sx={styles.numberStyle}>
              {endDate}
            </Typography>
            <Box sx={styles.subtitleStyle}>{`${t?.['End Date - Time']}`}</Box>
          </Box>
        </Box>
       <Box sx={[styles.boxStyle, { borderRight: 'none' }] }>
        <Box component={'img'} src={TimeSpend} alt='StartTime' sx={styles.iconContainer} />
          <Box sx={styles.TimeInfo}>
            <Typography variant="body1" sx={styles.numberStyle}>
              {timeTaken}
            </Typography>
            <Box sx={styles.subtitleStyle}>{`${t?.['Time Taken']}`}</Box>
          </Box>
        </Box>
    </Box>
  )
}
const styles = {
  timeContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: { xs: '0px', sm: '10px 0px' },
    backgroundColor: '#fff',
    border: '1px solid #ECEDF1',
    borderRadius: '15px',
    width: '100%',
    maxWidth: { xs: 'auto', sm: '100%' },
    boxSizing: 'border-box',
    height: { xs: '245px', sm: '110px' },
  },
  boxStyle: {
    boxSizing: 'border-box',
    maxWidth: { xs: '100%', sm: 'calc(33.33%)' },
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    borderRight: { xs: 'none', sm: '1px solid #ECEDF1' },
    borderBottom: { xs: '1px solid #ECEDF1', sm: 'none' },
    padding: { xs: '10px 8px', sm: '16px' },
    margin: { xs: '0', sm: '8px 0' },
    '&:last-child': {
      borderRight: 'none',
      borderBottom: 'none',
    },
  },
  iconContainer: {
    borderRadius: { xs: '50%', sm: '30px' },
    width: { xs: '19px', sm: '40px' },
    height: { xs: '29px', sm: '40px' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EDF9F0',
    p: { xs: '10px 15px', sm: '20px' },
    '& span': {
      width: { xs: '21px', sm: '40px' },
      height: { xs: '25px', sm: '40px' },
    },
    '& img': {
      width: { xs: '21px', sm: '40px' },
      height: { xs: '25px', sm: '40px' },
    },
  },
  TimeInfo: {
    maxWidth: { xs: '102px', sm: '100%' },
    marginLeft: { xs: '10px', sm: '16px' },
  },
  numberStyle: {
    fontFamily: 'Avenir 85 light',
    fontWeight: 500,
    fontSize: { xs: '12px', sm: '18px' },
    lineHeight: { xs: '18px', sm: '27px' },
  },
  subtitleStyle: {
    fontFamily: 'Avenir 85 light',
    fontWeight: 400,
    fontSize: { xs: '9px', sm: '14px' },
    lineHeight: { xs: '13px', sm: '21px' },
    marginTop: '5px',
    color: '#B4B4B9',
  },
};

export default TimeBox;
